import { http } from '@/api/Connect';
import { API_VERSION, BASE_WEB_OPERATOR } from '@/api/CopyStake/BaseUrls';
import { AxiosResponse } from 'axios';

import {
  EStreamingType,
  ICopyStakeStatsResponse,
  TStreamConfigurationPayload,
  TStreamConfigurationResponse
} from '@/api/schema';

const API_WEB_SETTINGS = (version: string = API_VERSION.V1): string =>
  `${BASE_WEB_OPERATOR(version)}/settings`;

export async function getStreamConfiguration(): Promise<TStreamConfigurationResponse> {
  return http
    .get(API_WEB_SETTINGS(API_VERSION.V2))
    .then(({ data }: AxiosResponse<TStreamConfigurationResponse>) => data);
}

export async function updateStreamConfiguration(
  payload: Partial<TStreamConfigurationPayload>
): Promise<TStreamConfigurationPayload> {
  return http
    .put(API_WEB_SETTINGS(API_VERSION.V2), payload)
    .then(({ data }: AxiosResponse<TStreamConfigurationPayload>) => data);
}

export async function getStreamerOnlineLimits(): Promise<ICopyStakeStatsResponse> {
  return http
    .get(
      `${API_WEB_SETTINGS()}/online-limits?streamingType=${EStreamingType.WHIP}`
    )

    .then(({ data }: AxiosResponse): ICopyStakeStatsResponse => data);
}

export async function getWebStreamerOnlineLimits(): Promise<ICopyStakeStatsResponse> {
  return http
    .get(
      `${API_WEB_SETTINGS()}/online-limits?streamingType=${EStreamingType.WEB}`
    )
    .then(({ data }: AxiosResponse): ICopyStakeStatsResponse => data);
}
